var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelefit = function SvgTelefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4-Sidebar-/-All",
    transform: "translate(-904.000000, -286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.Templates/01.Side-bar/Expand/Clinic-Copy-4",
    transform: "translate(888.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-screening",
    transform: "translate(0.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3.49999996 L4.99999996,3.49999996 C3.89543046,3.49999996 2.99999996,4.39543047 2.99999996,5.49999996 L2.99999996,14.5 C2.99999996,15.6045695 3.89543046,16.5 4.99999996,16.5 L15,16.5 C16.1045695,16.5 17,15.6045695 17,14.5 L17,5.49999996 C17,4.39543047 16.1045695,3.49999996 15,3.49999996 Z M15.75,6.49999997 L4.24999996,6.49999997 C4.11192878,6.49999997 3.99999996,6.38807116 3.99999996,6.24999998 L3.99999996,5.49999997 C4.00154495,4.94835644 4.44835644,4.50154495 4.99999996,4.49999997 L15,4.49999997 C15.5516436,4.50154495 15.998455,4.94835644 16,5.49999997 L16,6.24999998 C16,6.38807116 15.8880712,6.49999997 15.75,6.49999997 Z",
    id: "browsers",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telefit.4a3217cf.svg";
export { ForwardRef as ReactComponent };